var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpScoutLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 61,
    viewBox: "0 0 51 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.24026 35.4036L21.6921 17.9518C23.9553 15.7389 25.3635 12.6207 25.3635 9.20077C25.3635 5.83111 24.0056 2.71291 21.7927 0.5L4.34085 17.9518C2.07765 20.1647 0.669434 23.2829 0.669434 26.7029C0.669434 30.1228 2.02735 33.1907 4.24026 35.4036ZM46.4867 25.1941L29.0349 42.6459C26.7717 44.8588 25.3635 47.977 25.3635 51.3969C25.3635 54.7666 26.7214 57.8848 28.9343 60.0977L46.3861 42.6459C48.6493 40.433 50.0575 37.3148 50.0575 33.8948C50.0575 30.4749 48.6996 27.407 46.4867 25.1941ZM46.3861 18.0021C48.6493 15.7892 50.0575 12.671 50.0575 9.25105C50.0575 5.88139 48.6996 2.76321 46.4867 0.550296L4.29056 42.6962C2.02736 44.9594 0.619141 48.0273 0.619141 51.4975C0.619141 54.8672 1.97706 57.9854 4.18997 60.1983L46.3861 18.0021Z",
    fill: "#1087D8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpScoutLogo);
export default __webpack_public_path__ + "static/media/helpScoutLogo.3eba16008cffa67a9d74e796e6f1dacc.svg";
export { ForwardRef as ReactComponent };